/* eslint-disable react-hooks/exhaustive-deps */
import { useHistory, useLocation } from 'react-router';
import { axiosInstance, isEmptyData } from '../../utils/helper';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ImageLoader from '../../components/ImageLoader';
import Outlet from '../../components/Outlet';
import { setTag } from '../../store/reducers/tag';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import Loader from '../../components/Loader';
import { setOutlet } from '../../store/reducers/outlet';
import OutletPromotion from '../../components/Promotion/Outlet';

const Promotion = () => {
	console.log('Promotion');
	const dispatch = useDispatch();
	const location = useLocation();
	const history = useHistory();
	const [isLoading, setIsLoading] = useState(false);
	const param = new URLSearchParams(location.search);
	const tag = decodeURIComponent(param?.get('tag'));
	const tag_name = decodeURIComponent(param?.get('tag_name'));
	const banner_id = decodeURIComponent(param?.get('banner_id'));

	const user = useSelector((store) => store?.user || {});
	const section_id = decodeURIComponent(param?.get('section_id'));

	const [promo, setPromo] = useState(null);

	const handleGetPromo = async () => {
		try {
			setIsLoading(true);

			const headers = {
				'Content-Type': 'application/json',
			};
			const response = await axiosInstance.post('/banner/promotion', { banner_id: banner_id }, { headers: headers });
			if (response?.data?.status === 'ok' && !isEmptyData(response?.data?.data)) {
				const data = response?.data?.data;
				setPromo(data);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (isEmptyData(tag)) return;
		handleGetPromo();
	}, [tag]);

	useEffect(() => {
		if (promo?.tag_primary_id) {
			dispatch(setTag({ selected: promo?.tag_primary_id }));
		}
	}, [promo?.tag_primary_id]);

	// useEffect(() => {
	// 	if (!isEmptyData(tag)) {
	// 		dispatch(setTag({ selected: tag }));
	// 	}
	// }, [tag]);

	useEffect(() => {
		if (!isEmptyData(tag_name)) {
			setPromo({ tag_name });
		}
	}, [tag_name]);

	const handleGetCardDetail = async () => {
		try {
			setIsLoading(true);

			const headers = {
				'Content-Type': 'application/json',
			};
			const response = await axiosInstance.get(`/store/detail-card?latitude=${user?.latitude}&longitude=${user?.longitude}&sectionID=${section_id}`, { headers: headers });
			if (response?.data?.status === 'ok' && !isEmptyData(response?.data?.result)) {
				const data = response?.data?.result;
				setPromo({
					tag_name: data?.name,
				});
				dispatch(
					setOutlet({
						list: data?.outlets,
					}),
				);
			}
			setIsLoading(false);
		} catch (error) {
			console.log('error: ', error);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (isEmptyData(section_id)) return;
		handleGetCardDetail();
	}, [section_id]);

  useEffect(() => {
    if (isEmptyData(tag) && isEmptyData(section_id)) {
      return history.push('/')
    }
  }, [])

	return (
		<div className='flex flex-col min-h-screen relative bg-white'>
			{isLoading && <Loader overlay />}
			<div className={`bg-white p-4 flex flex-row items-center border-b-1 border-solid border-gray-200 sticky top-0 min-w-full min-h-10`}>
				<div className='flex flex-row justify-center items-center'>
					<ArrowLeftIcon className={`h-8 w-8 transition-all duration-500text-gray-900 p-1`} onClick={() => history.push('/')} />
					<div className={`text-gray-700 font-semibold pl-2 text-base transition-all duration-500 truncate max-w-[75vw] opacity-100 transform translate-y-0`}>{promo?.tag_name ?? ''}</div>
				</div>
			</div>
			<div className='p-4 flex-1 overflow-x-hidden overflow-y-scroll'>
				{promo?.banner_detail_image && <ImageLoader src={promo?.banner_detail_image} alt={promo?.banner_detail_image} className='w-full h-full max-h-64 object-fill rounded-xl' />}
				<div className={`${promo?.banner_detail_image ? 'bg-gray-100 h-2 my-4 !-mx-[2rem]' : 'hidden'}`} />
				{!isEmptyData(promo?.tag_primary_id || tag) && <Outlet />}
				{!isEmptyData(section_id) && <OutletPromotion />}
			</div>
		</div>
	);
};

export default Promotion;
